import React, { useRef } from "react";
import "./SquareGrid.css";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import { SendIcon } from "./icons";

interface RangeInputProps {
  newInput: (value: number) => void;
}

const RangeInput: React.FC<RangeInputProps> = ({ newInput }) => {
  const maximumRef = useRef<HTMLInputElement | null>(null);
  const buttonRef = useRef<HTMLButtonElement | null>(null);

  function onEnter() {
    const raw = maximumRef.current?.value ?? "144";
    const value = Number(raw);
    if (!Number.isNaN(value)) {
      newInput(value);
    }
  }

  return (
    <div>
      <span>
        Generate 100 random points between <i>n</i>=1 and <i>n</i>=
      </span>
      <TextField
        variant="standard"
        sx={{ width: "9ch", ml: 0.5 }}
        id="RandomRange"
        type="number"
        defaultValue={144}
        inputRef={maximumRef}
        onKeyDown={(ev) => {
          if (ev.key === "Enter") {
            buttonRef.current?.click();
            ev.preventDefault();
          }
        }}
      />
      <IconButton
        aria-label="input"
        size="small"
        ref={buttonRef}
        onClick={onEnter}
      >
        <SendIcon ic="" />
      </IconButton>
    </div>
  );
};

export default RangeInput;


